// The message asking an organiser for their pictures.

/** Parts of a site's or a handle's name that say nothing about whose it is. */
const GENERIC = new Set([
  'www', 'at', 'co', 'com', 'de', 'eu', 'io', 'net', 'org', 'wien', 'vienna', 'official', 'live', 'club',
  'assets', 'cdn', 'images', 'img', 'media', 'static', 'cloud', 'events', 'fra1', 'instagram', 'cdninstagram',
]);

/** File storage, not a site the organiser would know as theirs (flucc's pictures lie on DigitalOcean). */
const STORAGE = ['digitaloceanspaces.com', 'amazonaws.com', 'cloudfront.net', 'googleusercontent.com'];

/** Whether a site is the account's own, judged by its name: u4.at for @u4_vienna, clublucia.at for @lucia.vienna. */
export const isOwnSite = (host, handle) => {
  const site = String(host || '').toLowerCase();
  if (!site || STORAGE.some((storage) => site === storage || site.endsWith(`.${storage}`))) return false;
  const parts = String(handle || '').toLowerCase().split(/[._]+/).filter((part) => part && !GENERIC.has(part));
  const name = parts.join('');
  if (!name) return false;
  return site.split(/[.-]+/)
    .filter((word) => word.length >= 2 && !GENERIC.has(word))
    // Short words like "u4" only as a whole part of the handle, so "ra" of ra.co matches nobody.
    .some((word) => (word.length >= 3 ? name.includes(word) || (name.length >= 3 && word.includes(name)) : parts.includes(word)));
};

/** The account's own site when most of its pictures come from there, or null. */
export const ownSite = (account) => {
  const sources = Array.isArray(account?.sources) ? account.sources : [];
  const total = sources.reduce((sum, source) => sum + source.pictures, 0);
  const own = sources.find((source) => isOwnSite(source.host, account.handle));
  return own && own.pictures * 2 >= total ? own.host : null;
};

/** The message to an organiser, with their handle in it, and their site when their pictures come from it. */
export const requestText = (handle, site = null) =>
  `Hey${handle ? ` @${handle}` : ''}! 👋 Wir sind Schick Vienna und würden eure Events & Bilder gerne künftig `
  + 'in unserer App mit Instagram-Verlinkung zeigen. Passt das für euch und habt ihr die nötigen Bildrechte '
  + '(auch vom Fotografen)? 😊 Falls nicht, werden wir die Bilder natürlich nicht anzeigen!'
  + (site ? `\n\nAußerdem: Dürfen wir auch die Bilder von Events verwenden, die bei euch stattfinden und auf ${site} angezeigt werden?` : '');
